(() => {
  const body = document.body;
  if (body.hasAttribute('data-ac-smooth-scroll-bound')) return;
  body.setAttribute('data-ac-smooth-scroll-bound', '');

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controller = new AbortController();
  let lenis;
  let frameId;
  let ticker;
  let tickerPolicy;
  let destroyed = false;
  const idleClock = body.classList.contains('ac-reference--home') || Boolean(document.querySelector('[data-ac-ref-product]'));
  let clockTime = 1;
  let lastClockTime;

  const advance = (time) => {
    if (!lenis) return;
    if (idleClock) {
      // Count only attached time. An idle gap must not become one large
      // interpolation step when wheel or programmatic scrolling resumes.
      clockTime += Math.max(0, time - (lastClockTime ?? time));
      lastClockTime = time;
      lenis.raf(clockTime);
      if (lenis.isScrolling !== 'smooth') detachClock();
    } else lenis.raf(time);
  };

  const frame = (time) => {
    if (!lenis) return;
    advance(time);
    if (!idleClock || lenis.isScrolling === 'smooth') frameId = window.requestAnimationFrame(frame);
  };
  const tick = (seconds) => advance(seconds * 1000);
  const detachClock = () => {
    ticker?.remove(tick);
    ticker = undefined;
    window.cancelAnimationFrame(frameId);
    frameId = undefined;
    lastClockTime = undefined;
  };
  const attachClock = () => {
    if (!lenis || lenis.isStopped || ticker || frameId !== undefined) return;
    if (idleClock && lenis.isScrolling !== 'smooth') return;
    const gsapTicker = window.gsap?.ticker;
    // wake() updates a sleeping ticker's time before we record the new origin.
    if (idleClock) gsapTicker?.wake?.();
    lastClockTime = gsapTicker ? gsapTicker.time * 1000 : performance.now();
    if (gsapTicker) {
      ticker = gsapTicker;
      ticker.add(tick);
    } else frameId = window.requestAnimationFrame(frame);
  };
  const stop = () => {
    lenis?.stop();
    detachClock();
  };
  const start = () => {
    if (window.AcLayerManager?.isLocked()) return;
    lenis?.start();
    attachClock();
  };
  const update = () => window.ScrollTrigger?.update?.();
  const refresh = () => {
    if (!destroyed && lenis) window.ScrollTrigger?.refresh?.();
  };
  const deactivate = () => {
    detachClock();
    lenis?.destroy();
    lenis = undefined;
    // This owner is the sole ticker timing-policy writer in the theme.
    tickerPolicy?.lagSmoothing(500, 33);
    tickerPolicy = undefined;
    delete window.AcSmoothScroll;
  };
  const sync = () => {
    const reduced = body.dataset.acMotion === 'reduced' || motionQuery.matches;
    body.classList.toggle('ac-motion-reduced', reduced);
    if (reduced || body.dataset.acSmoothScroll !== 'true' || !window.Lenis) {
      deactivate();
      return;
    }
    if (lenis) return;

    lenis = new window.Lenis({
      autoRaf: false,
      lerp: 0.1,
      smoothWheel: true,
      syncTouch: false,
    });
    if (idleClock) {
      clockTime = 1;
      lenis.raf(clockTime);
      const scrollTo = lenis.scrollTo;
      // Lenis routes wheel interpolation through this same public method.
      // Native touch scrolling still emits its existing scroll/update events.
      lenis.scrollTo = function (...args) {
        const result = scrollTo.apply(this, args);
        attachClock();
        return result;
      };
    }
    lenis.on('scroll', update);
    tickerPolicy = window.gsap?.ticker;
    tickerPolicy?.lagSmoothing(0);
    attachClock();
    if (window.AcLayerManager?.isLocked()) stop();
    window.AcSmoothScroll = { lenis, refresh, start, stop };
  };

  sync();
  // The homepage scene owner refreshes after pending fonts settle. A second
  // refresh here repeats the same layout measurements during initialization.
  if (!body.classList.contains('ac-reference--home')) document.fonts?.ready?.then(refresh);
  motionQuery.addEventListener('change', sync, { signal: controller.signal });
  const observer = new MutationObserver(sync);
  observer.observe(body, { attributes: true, attributeFilter: ['data-ac-motion', 'data-ac-smooth-scroll'] });
  window.addEventListener('pageshow', sync, { signal: controller.signal });

  window.addEventListener(
    'pagehide',
    (event) => {
      if (event.persisted) return;
      destroyed = true;
      controller.abort();
      observer.disconnect();
      deactivate();
      body.removeAttribute('data-ac-smooth-scroll-bound');
    },
    { signal: controller.signal },
  );
})();
